RivalIQ.apps.AccountSettings.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s, moment, window) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const UserCount = Marionette.ItemView.extend({
        template: '#userCountTemplate'
    });

    const ResetPassword = Marionette.ItemView.extend({
        template: '#userResetPasswordModalTemplate',

        ui: {
            modal: '.modal',
            save: '.x-save'
        },

        events: {
            'click @ui.save': 'onSave'
        },

        onSave: function () {
            const me = this;
            me.ui.save.button('loading');

            me.model.resetPassword()
                .done(function () {
                    me.ui.modal.modal('hide');
                    RivalIQ.execute('alert:info', `Password reset mail sent to ${me.model.get('email')}`);
                })
                .fail(function () {
                    me.ui.save.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        }
    });

    const Reinvite = Marionette.ItemView.extend({
        template: '#userReinviteModalTemplate',

        ui: {
            modal: '.modal',
            save: '.x-save'
        },

        events: {
            'click @ui.save': 'onSave'
        },

        onSave: function () {
            const me = this;
            me.ui.save.button('loading');

            me.model.reinvite()
                .done(function () {
                    me.ui.modal.modal('hide');
                    RivalIQ.execute('alert:info', `Invitation mail sent to ${me.model.get('email')}`);
                })
                .fail(function () {
                    me.ui.save.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        }
    });

    const Revoke = Marionette.ItemView.extend({
        template: '#userRevokeModalTemplate',

        ui: {
            modal: '.modal',
            save: '.x-save'
        },

        events: {
            'click @ui.save': 'onSave'
        },

        serializeData: function () {
            const me = this;

            return _.defaults(me.model.toJSON(), {
                first_name: '',
                last_name: ''
            });
        },

        onSave: function () {
            const me = this;
            me.ui.save.button('loading');

            me.model.destroy()
                .done(function () {
                    me.ui.modal.modal('hide');
                    RivalIQ.execute('alert:info', `Access Revoked for ${me.model.get('email')}`);
                })
                .fail(function () {
                    me.ui.save.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        }
    });

    const UserEdit = App.views.Edit.extend({
        template: '#userEditModalTemplate',
        modelEvents: {
            'sync': 'onSync'
        },
        fields: [
            'name',
            'role'
        ],

        onSync: function () {
            const me = this;
            RivalIQ.execute('alert:info', `${me.model.get('email')} saved`);
            RivalIQ.execute('hide:modal');
            RivalIQ.state.account.trigger('change:user', me.model);
        }
    });

    const Dropdown = Marionette.ItemView.extend({
        tagName: 'td',
        template: '#usersDropdownCellTemplate',

        events: {
            'click .x-edit': 'onEdit',
            'click .x-edit-email': 'onEditEmail',
            'click .x-revoke': 'onRevoke',
            'click .x-reset': 'onReset',
            'click .x-reinvite': 'onReinvite'
        },

        templateHelpers: function () {
            const me = this;
            const model = me.model.get('data');

            const isTrialerWithTrialPlan = RivalIQ.state.account.isTrialerWithTrialPlan();

            return {
                canEditEmail: !isTrialerWithTrialPlan,
                canRevoke: RivalIQ.state.user.can('destroy', model) && !isTrialerWithTrialPlan,
                canResend: model.isInvited() && RivalIQ.state.user.can('invite', RivalIQ.state.account) && !isTrialerWithTrialPlan
            };
        },

        onReset: function () {
            const me = this;

            RivalIQ.execute('show:modal', new ResetPassword({
                model: me.model.get('data')
            }));
        },

        onRevoke: function () {
            const me = this;

            RivalIQ.execute('show:modal', new Revoke({
                model: me.model.get('data')
            }));
        },

        onReinvite: function () {
            const me = this;

            RivalIQ.execute('show:modal', new Reinvite({
                model: me.model.get('data')
            }));
        },

        onEditEmail: function () {
            const me = this;
            const model = me.model.get('data');

            RivalIQ.execute('show:modal', new UserEdit({
                model: model,
                fields: [
                    'email'
                ]
            }));
        },

        onEdit: function () {
            const me = this;
            const model = me.model.get('data');

            RivalIQ.execute('show:modal', new UserEdit({
                model: model
            }));
        }
    });

    const EmailCellView = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'cell-middle',
        template: '#usersEmailCellTemplate',
        serializeData: function () {
            const me = this;
            return me.model.get('data').toJSON();
        },
        templateHelpers: function () {
            const me = this;
            const model = me.model.get('data');

            return {
                isInvited: model.isInvited()
            };
        }
    });

    const LandscapesCell = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'cell-middle',
        template: '#usersLandscapesCellTemplate',

        ui: {
            info: '.fa-info-circle'
        },

        serializeData: function () {
            const me = this;
            return me.model.get('data').toJSON();
        },

        templateHelpers: function () {
            const me = this;
            const model = me.model.get('data');
            const landscapes = RivalIQ.state.user.get('landscapes');
            const landscapeId = _.get(model.get('readonly_settings'), 'landscape_id');
            const landscape = _.find(landscapes, {
                id: landscapeId
            });

            return {
                limitedAccess: !model.can('listLandscapes', RivalIQ.state.account),
                landscapeName: _.get(landscape, 'name', '')
            };
        }
    });

    const AccountEdit = Marionette.ItemView.extend({
        template: '#accountEditTemplate',

        ui: {
            modal: '.modal',
            infoBubbles: '.fa-info-circle',
            saveBtn: '.x-save'
        },

        events: {
            'click @ui.saveBtn': 'onSave'
        },

        behaviors: {
            AttributeBuilder: {},
            FormValidator: {}
        },

        onBeforeShow: function () {
            const me = this;
            me.ui.infoBubbles.popover();
        },

        onSave: function () {
            const me = this;

            me.ui.saveBtn.button('loading');
            me.triggerMethod('resetValidationErrors');

            const result = me.model.save();

            if (!result) {
                return me.ui.saveBtn.button('reset');
            }

            result
                .done(function () {
                    me.ui.modal.modal('hide');
                    RivalIQ.execute('alert:info', 'Account saved');
                })
                .fail(function () {
                    me.ui.saveBtn.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        }
    });

    const Invite = App.views.Edit.extend({
        getTemplate: function () {
            const me = this;

            if (me.isAtLimit) {
                return '#userInviteLimitTemplate';
            }

            return '#userInviteTemplate';
        },

        onBeforeShow: function () {
            const me = this;
            App.views.Edit.prototype.onBeforeShow.apply(me, arguments);
            me.onRoleChange(me.model.get('role_id'));
        },

        initialize: function () {
            const me = this;

            App.views.Edit.prototype.initialize.call(me);

            const rivaliqNormalMsg = [
                `I'd like to invite you to our team's Rival IQ account. We use Rival IQ to measure our digital marketing analytics and keep track of our competitors.`,
                '',
                'Use this link to set up your account and we can share reports and data from our account.',
                '',
                'Thanks,',
                `${RivalIQ.state.user.get('first_name')}\n`
            ].join('\n');

            const rivaliqReadOnlyMsg = [
                `I've created reports for you on Rival IQ and would like to invite you to view your data.`,
                '',
                'Use this link to finish setting up your account by picking a password.',
                '',
                'Thanks,',
                `${RivalIQ.state.user.get('first_name')}\n`
            ].join('\n');

            const quidCompeteNormalMsg = [
                `I’d like to invite you to our team’s Quid Compete account. We use Quid Compete to analyze our digital marketing, keep track of our competitors, and spot trends in our industry.`,
                '',
                'Use this link to set up your account so we can share reports, data, and insights.',
                '',
                'Thanks,',
                `${RivalIQ.state.user.get('first_name')}\n`
            ].join('\n');

            const quidCompeteReadOnlyMsg = [
                `I’ve created reports for you on Quid Compete and would like to invite you to view your data. We use Quid Compete to analyze our digital marketing, keep track of our competitors, and spot trends in our industry.`,
                '',
                'Use this link to finish setting up your account by picking a password.',
                '',
                'Thanks,',
                `${RivalIQ.state.user.get('first_name')}\n`
            ].join('\n');

            if (RivalIQ.state.account.isQuidAccountGroup()) {
                me.normalMsg = quidCompeteNormalMsg;
                me.readOnlyMsg = quidCompeteReadOnlyMsg;
            } else {
                me.normalMsg = rivaliqNormalMsg;
                me.readOnlyMsg = rivaliqReadOnlyMsg;
            }
        },

        modelEvents: {
            'sync': 'afterSave',
            'form:role_id': 'onRoleChange'
        },

        loadData: function (callback) {
            const me = this;

            RivalIQ.data.users.fetch()
                .done(function (users) {
                    me.collection = users;
                    me.isAtLimit = users.length >= RivalIQ.state.account.getMaxUsers();

                    if (me.isAtLimit) {
                        me.trackLimitHit();
                    }

                    callback();
                });
        },

        onRoleChange: function (roleId) {
            const me = this;
            const existingMsg = me.$('[name="message"]').val();

            // if the message is empty or one of our standard messages, update it
            if (_.isEmpty(existingMsg) || existingMsg === me.normalMsg || existingMsg === me.readOnlyMsg) {
                const msg = (Number(roleId) === RivalIQ.enums.roles.readOnly.id ? me.readOnlyMsg : me.normalMsg);
                me.$('[name="message"]').val(msg);
            }
        },

        afterSave: function () {
            const me = this;

            me.collection.add(me.model);
            RivalIQ.execute('hide:modal');
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.InvitedUser);
        },

        onEmailCollision: function () {
            const me = this;

            if (me.collection.findWhere({
                email: me.model.get('email')
            })) {
                return me.triggerMethod('display:error', 'email', 'This user is already part of your account.');
            }

            RivalIQ.execute('show:modal', {
                contentText: RivalIQ.strings.email_collision,
                actions: [
                    {
                        html: 'Close',
                        className: 'btn btn-default',
                        attributes: {
                            type: 'button',
                            'data-dismiss': 'modal'
                        }
                    }
                ]
            });

            me.trackEmailCollision();
        },

        trackEmailCollision: function () {
            const me = this;

            $.post('/api/triggers', {
                type: 'email',
                trigger_type: 'user_invite_email_collision',
                data: {
                    email: me.model.get('email'),
                    role_id: me.model.get('role_id')
                }
            });
        },

        trackLimitHit: function () {
            $.post('/api/triggers', {
                type: 'email',
                trigger_type: 'user_limit_hit'
            });
        },

        showIntercom: function () {
            RivalIQ.execute('hide:modal');
            // NOTE it is possible that diligent blocking extensions might
            // prevent Intercom from loading, so we should guard against it
            if (window.Intercom) {
                window.Intercom('show');
            }
        }
    });

    const tableConfig = {
        className: 'table',
        columns: [
            {
                name: 'First',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return model.get('first_name');
                }
            },
            {
                name: 'Last',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return model.get('last_name');
                }
            },
            {
                name: 'Email',
                cellView: EmailCellView
            },
            {
                name: 'Role',
                cellClassName: 'cell-middle',
                value: function (model) {
                    const role = model.getRole();
                    let value = role.get('displayName');
                    if (role.id === RivalIQ.enums.roles.readOnly.id) {
                        value += ' <span class="fa fa-users"></span>';
                    }
                    return value;
                }
            },
            {
                name: 'Landscape',
                cellView: LandscapesCell
            },
            {
                name: 'Last Active',
                cellClassName: 'cell-middle',
                value: function (model) {
                    const lastActive = model.get('last_activity_at');
                    return (lastActive ? moment.utc(lastActive).fromNow() : 'Never');
                }
            },
            {
                name: '',
                cellClassName: 'cell-middle',
                cellView: Dropdown
            }
        ]
    };

    const Users = widgets.Users = RivalIQ.views.LoadingTableView.mixin({
        config: tableConfig,
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        loadData: function (callback) {
            const me = this;

            $.when(RivalIQ.state.account.getUsers(), RivalIQ.data.landscapes.fetch())
                .done(function (users, landscapes) {
                    users.landscapes = landscapes;
                    me.model = new Backbone.Model({
                        data: users
                    });

                    me.listenTo(users, 'sync', me.render);
                    me.listenTo(users, 'add', me.onRenderLoaded);
                    me.listenTo(users, 'remove', me.render);

                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedAccountUsers);

                    callback();
                });
        }
    });

    const Panel = Dashboard.views.DetailsPanel.extend({
        showActions: function () {
            const me = this;

            // NOTE: can't use loadData here because showActions is called before data is loaded :(
            RivalIQ.data.users.fetch()
                .done(function (users) {
                    const model = new Backbone.Model({
                        users: users.length,
                        maxUsers: RivalIQ.state.account.getMaxUsers()
                    });
                    const view = new UserCount({
                        model: model
                    });
                    if (me.actions) {
                        me.actions.show(view);
                    }
                });
        }
    });

    function openFullUserModal() {
        const view = new Invite({
            model: new RivalIQ.models.User({
                teams: [],
                role_id: RivalIQ.enums.roles.full.id,
                account_id: RivalIQ.state.account.get('id')
            }),
            fields: [
                'email',
                'role'
            ],
            rolesToShow: [RivalIQ.enums.roles.full.id],
            title: 'Invite a User',
            description: null
        });

        RivalIQ.execute('show:modal', view);
    }

    function openReadOnlyUserModal() {
        const view = new Invite({
            model: new RivalIQ.models.User({
                teams: [],
                role_id: RivalIQ.enums.roles.readOnly.id,
                account_id: RivalIQ.state.account.get('id')
            }),
            fields: [
                'email',
                'role'
            ],
            rolesToShow: [RivalIQ.enums.roles.readOnly.id],
            title: 'Invite a Read-Only User',
            description: RivalIQ.strings.account_invite_read_only_description
        });

        RivalIQ.execute('show:modal', view);
    }

    const InviteUserDropdown = Marionette.ItemView.extend({
        template: '#userInviteDropdownTemplate',
        className: 'dropdown hidden-xs x-export-hide',

        events: {
            'click .x-invite-full-user': 'onInviteFullUser',
            'click .x-invite-readonly-user': 'onInviteReadOnlyUser'
        },

        onInviteFullUser: openFullUserModal,
        onInviteReadOnlyUser: openReadOnlyUserModal
    });

    const DetailsLayout = Dashboard.views.DetailsLayout.extend({
        template: '#accountUsersLayoutTemplate',
        showLeftToolbarActions: _.noop,
        panelView: Panel,
        showToolbarActions: function () {
            const me = this;

            me.actions.show(new RivalIQ.views.Link({
                className: 'btn btn-default',
                linkName: 'Edit Account Name',
                action: function () {
                    RivalIQ.execute('show:modal', new AccountEdit({
                        model: RivalIQ.state.account
                    }));
                }
            }), {
                preventDestroy: true
            });


            if (RivalIQ.state.account.inBeta('client_account')) {
                me.actions.show(new InviteUserDropdown(), {
                    preventDestroy: true
                });
            } else {
                me.actions.show(new RivalIQ.views.Link({
                    className: 'btn btn-default btn-primary',
                    linkName: '<span class="fa fa-plus"></span> Invite User',
                    action: openFullUserModal
                }), {
                    preventDestroy: true
                });
            }
        },

        getBodyView: function () {
            const me = this;
            return me.panelView;
        }
    });

    const Widget = widgets.Users = Dashboard.models.Widget.extend({
        view: Users,
        detailPanelView: DetailsLayout,
        viewMore: false,
        exportFormats: [],
        title: function () {
            return [
                RivalIQ.state.account.get('name'),
                RivalIQ.strings.users_widget_title
            ].join(' ');
        },
        description: RivalIQ.strings.users_widget_description
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.USERS, Widget);

}, window.s, window.moment, window);
